export const audienceConstants = {
  SET_AUDIENCE_FIELD: 'SET_AUDIENCE_FIELD',
  SELECT_AUDIENCE_FIELD: 'SELECT_AUDIENCE_FIELD',
  RESET_AUDIENCE_STORE: 'RESET_AUDIENCE_STORE',
  SET_AUDIENCE_WARNING: 'SET_AUDIENCE_WARNING',
  SET_PREBID_SEGMENT_IDS: 'SET_PREBID_SEGMENT_IDS',
};
